import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-survey-final-decision-selector',
  templateUrl: './survey-final-decision-selector.component.html',
  styleUrls: ['./survey-final-decision-selector.component.scss'],
  standalone: false,
})
export class SurveyFinalDecisionSelectorComponent {
  @Input() element: any;
  @Input() survey: any;
  @Input() statuses: Array<{ id: string; title: string; titleNoRev: string; icon: string; bgcolor: string }> = [];

  @Output() decisionChange = new EventEmitter<{ element: any; decision: string | null }>();

  get selectedStatus() {
    if (!this.element?.final_decision) return null;
    return this.statuses.find((s) => s.id === this.element.final_decision) ?? null;
  }

  get displayLabel(): string {
    const s = this.selectedStatus;
    if (!s) return '';
    return this.survey?.is_revised ? s.title : s.titleNoRev;
  }

  onSelectDecision(decision: string) {
    this.decisionChange.emit({ element: this.element, decision });
  }
}
